import { ThemeSSRManager } from '../src/ThemeSSRManager.ts';

export const themeSSRManager: ThemeSSRManager = new ThemeSSRManager();
